// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"MainLayout_MainContainer__5vqrg","MainRow":"MainLayout_MainRow__lwH0i","SideBar":"MainLayout_SideBar__3Bf0E","MainContent":"MainLayout_MainContent__QXAeg"};